export function easeOutCirc(x) {
  return sqrt(1 - pow(x - 1, 2));
}

export function easeOutQuart(x) {
  return 1 - pow(1 - x, 4);
}

export function easeOutSine(x) {
  return sin((x * PI) / 2);
}

export function easeInCubic(x) {
  return x * x * x;
}

export function easeOutQuint(x) {
  return 1 - pow(1 - x, 5);
}